const pmdrs = require("./pmdrs-ol").default //standard js import
module.exports = pmdrs;//webpack library
